import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import CompanyCard from '@/components/CompanyCard'
import Vue from 'vue'

const outsourcingQuotesModel = vm => ({
  title: vm.$gettext('Outsourcing Quotes'),
  endpoint: 'outsourcing-quotes',
  allowNew: true,
  allowDelete: true,
  allowBulk: true,
  countrize: 'area_to.country',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'area_id_from',
      label: vm.$gettext('Origin Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Origin Area this quote is for'),
      default: null
    },
    {
      key: 'area_id_to',
      label: vm.$gettext('Destination Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Destination Area this quote is for'),
      default: null
    },
    {
      key: 'postal_code_to',
      label: vm.$gettext('Destination Postal Code'),
      editable: true,
      description: vm.$gettext(
        'Specific destination postal code this quote is for, is for highly specific quotes'
      ),
      type: 'text'
    },
    {
      key: 'company_id_customer',
      label: vm.$gettext('Customer Company'),
      editable: true,
      componentEdit: (value, key, item) => {
        return {
          is: CompanyAutocomplete,
          props: {
            required: false,
            restrictTo: [['relationship', 'eq', 'client']],
            preQuery: item.company?.name || null
          },
          on: {
            selected: result => {
              if (result) {
                item[key] = result.id
              } else {
                item[key] = null
              }
            }
          }
        }
      },
      formatter: (value, key, item) => {
        return item.company
          ? new Vue({
              ...CompanyCard,
              parent: this,
              propsData: {
                company: item.company,
                profilePicture: false,
                withTitles: false,
                withContact: false
              }
            }).$mount().$el.outerHTML
          : ''
      }
    },
    {
      key: 'size_id',
      label: vm.$gettext('Shipping Size'),
      type: 'select',
      options: 'shippingSizes',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      description: vm.$gettext('Shipping size this quote is for'),
      default: null
    },
    {
      key: 'shipping_type_id',
      label: vm.$gettext('Shipping Type'),
      type: 'select',
      options: 'shippingTypes',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      description: vm.$gettext('Shipping type this quote is for'),
      default: null
    },
    {
      key: 'company_id_provider',
      label: vm.$gettext('Provider Company'),
      editable: true,
      required: true,
      componentEdit: (value, key, item) => {
        return {
          is: CompanyAutocomplete,
          props: {
            required: true,
            restrictTo: [['relationship', 'eq', 'provider']],
            preQuery: item.provider ? item.provider.name : null
          },
          on: {
            selected: result => {
              if (result) {
                item[key] = result.id
              } else {
                item[key] = null
              }
            }
          }
        }
      },
      formatter: (value, key, item) => {
        return item.provider
          ? new Vue({
              ...CompanyCard,
              parent: this,
              propsData: {
                company: item.provider,
                profilePicture: false,
                withTitles: false,
                withContact: false
              }
            }).$mount().$el.outerHTML
          : ''
      }
    },
    {
      key: 'price',
      label: vm.$gettext('Price'),
      editable: true,
      required: true,
      description: vm.$gettext(
        'Price agreed with the supplier for shipments that match this quote. (This is the quote itself)'
      ),
      type: 'number',
      step: '0.1'
    },
    {
      key: 'applies_automatically',
      label: vm.$gettext('Applies Automatically'),
      sortable: true,
      editable: true,
      type: Boolean,
      required: false,
      default: 0,
      formatter: (value, key, item) => {
        return value
          ? `<strong class="text-success">${vm.$gettext('YES')}</strong>`
          : `<strong class="text-danger">${vm.$gettext('NO')}</strong>`
      }
    },
    {
      key: 'distribution_factor',
      label: vm.$gettext('Distribution Factor'),
      editable: true,
      description: vm.$gettext(
        'From 0 to 127. In case of quote collisions, it is a number which will allow to decide to which provider gets assigned'
      ),
      type: 'integer'
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      sortable: true,
      editable: true,
      type: Boolean,
      required: false,
      default: 0,
      formatter: (value, key, item) => {
        return value
          ? `<strong class="text-success">${vm.$gettext('YES')}</strong>`
          : `<strong class="text-danger">${vm.$gettext('NO')}</strong>`
      }
    }
  ],
  filters: [
    'id',
    'area_from.name',
    'area_to.name',
    'postal_code_to',
    'provider.name',
    'provider.id',
    'size.name',
    'shipping_type.name',
    'company.name',
    'company.id',
    'price',
    'applies_automatically',
    'active'
  ],
  includes: ['area_from', 'area_to', 'company', 'provider']
})

export default outsourcingQuotesModel
